<template>
  <div>
    <div
      class="overlay"
      v-if="state.isMenuMobileShowing"
      @click="closeMobileNav">
    </div>
    <div
      id="sidenavMobile"
      ref="sidenavMobile"
      class="sidenav">
      <div class="nav-user">
        <div class="nav-item-detail">
          <router-link
            class="navbar-brand"
            :to="`/${teamName}`">
            <img
              class="byteark-logo"
              :src="byteArkLogo"
              alt="ByteArk TimeMachine">
            <span class="brand">ByteArk TimeMachine</span>
          </router-link>
        </div>
      </div>
      <div
        class="navbar navbar-mobile"
        @click.stop="onCloseOutSideArea">
        <ul class="nav navbar-nav">
          <li class="nav-item">
            <router-link class="nav-link" :to="`/${teamName}/capture`">
              {{$t('capture.title')}}
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="`/${teamName}/clips`">
              {{$t('browser.title')}}
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="`/${teamName}/reports`">
              {{$t('report.title')}}
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="`/${teamName}/timeshift`">
              {{$t('timeShift.title')}}
            </router-link>
          </li>
        </ul>
      </div>
      <div class="navbar navbar-user">
        <div class="user-container">
          <Logo :user="currentUser" />
          <div class="name-container">
            <p class="user-name">
              {{currentUser.name}}
            </p>
            <p class="team-name">
              {{teamName}}
            </p>
          </div>
        </div>
        <ManageAccountLanguage noStyle />
        <a class="nav-item" :href="`${baseURL}/accounts/logout?team=${teamName}`">
          <i class="fas fa-sign-out-alt"></i> {{$t('common:signOut')}} {{teamName}}
        </a>
      </div>
    </div>
    <nav class="navbar navbar-expand-lg navbar-dark">
      <div class="container">
        <button
          class="navbar-toggler mr-4"
          type="button"
          @click.stop="openMobileNav">
          <span class="navbar-toggler-icon"></span>
        </button>
        <router-link class="navbar-brand" :to="`/${teamName}`">
          <img
            class="byteark-logo"
            :src="byteArkLogo"
            alt="ByteArk TimeMachine">
          <span class="brand">ByteArk TimeMachine</span>
        </router-link>
        <div class="navbar-collapse collapse" id="navbarNav">
          <ul class="nav navbar-nav">
            <li class="nav-item">
              <router-link class="nav-link" :to="`/${teamName}/capture`">
                {{$t('capture.title')}}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="`/${teamName}/clips`">
                {{$t('browser.title')}}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="`/${teamName}/reports`">
                {{$t('report.title')}}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="`/${teamName}/timeshift`">
                {{$t('timeShift.title')}}
              </router-link>
            </li>
          </ul>
          <ul class="nav nav-auth ml-auto">
            <li class="nav-item">
              <DropdownButton
                class="submenu-container float-right">
                <div slot="button">
                  <div class="user-container">
                    <Logo :user="currentUser" />
                    <div class="name-container">
                      <p class="user-name">
                        {{currentUser.name}}
                      </p>
                      <p class="team-name">
                        {{teamName}}
                      </p>
                    </div>
                    <div class="action">
                      <i class="fas fa-angle-down ml-2"></i>
                    </div>
                  </div>
                </div>
                <div>
                  <ManageAccountProfile />
                  <ManageAccountLanguage />
                  <a class="dropdown-item" :href="`${baseURL}/accounts/logout?team=${teamName}`">
                    <i class="fas fa-sign-out-alt"></i> {{$t('common:signOut')}} {{teamName}}
                  </a>
                </div>
              </DropdownButton>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Logo from '@/components/elements/Logo.vue';
import DropdownButton from '@/components/elements/DropdownButton.vue';
import ManageAccountLanguage from '@/components/elements/ManageAccountLanguage.vue';
import ManageAccountProfile from '@/components/elements/ManageAccountProfile.vue';

const byteArkLogo = require('@/assets/images/byteark-logo-monotone.svg');

export default {
  components: {
    DropdownButton,
    Logo,
    ManageAccountLanguage,
    ManageAccountProfile,
  },
  data() {
    return {
      byteArkLogo,
      state: {
        isMenuMobileShowing: false,
      },
    };
  },
  computed: {
    ...mapGetters(['currentUser', 'isLoading', 'channels']),
    teamName() {
      return this.$route.params.teamName;
    },
    baseURL() {
      return process.env.VUE_APP_ORIGIN || window.location.origin;
    },
    hasChannel() {
      return this.channels && this.channels.length !== 0;
    },
  },
  methods: {
    openMobileNav() {
      this.state.isMenuMobileShowing = true;
      this.$refs.sidenavMobile.style.transform = 'translateX(0)';
    },
    closeMobileNav() {
      this.state.isMenuMobileShowing = false;
      this.$refs.sidenavMobile.style.transform = 'translateX(-300px)';
    },
    onCloseOutSideArea(event) {
      // if click on anything except the modal itself, close the modal
      if (event.target.closest('.navbar-mobile')) {
        this.closeMobileNav();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/variables.scss';

.md-theme-default a.navbar-brand:not(.md-button) {
  color: #FFF;
}

.navbar {
  background-color: $dark-nav;
}

.overlay {
  position: fixed;
  z-index: 100;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.byteark-logo {
  width: 32px;
  margin-right: 10px;
  margin-top: -6px;
}

.dropdown-item {
  color: #FFF !important;
}

.user-container {
  display: flex;
  justify-content: center;
  align-items: center;
  .name-container {
    margin-left: 6px;
    text-align: left;
    line-height: 1.3;
  }
  .user-name {
    margin: 0;
  }
  .team-name {
    margin: 0;
    font-size: 12px;
  }
}

.nav-user {
  display: flex;
  flex-direction: row;
  padding-top: 0;
  padding-bottom: 0;

  // every child div inside nav-user
  > div {
    display: flex;
    justify-content: space-between;
  }

  .nav-item-detail {
    flex-direction: column;
    align-items: flex-start;

    .primary {
      font-weight: bold;
      color: $gray-100;
      line-height: 1.1;
    }

    .secondary {
      display: flex;
      align-self: flex-start;
      width: 100%;
      justify-content: space-between;

      font-size: $font-size-sm * 0.85;
    }

  }

  .nav-item-action {
    align-items: flex-end;
    align-self: center;
  }
}

/* The side navigation menu */
.sidenav {
  height: 100%;
  width: 300px;
  position: fixed;
  z-index: 300;
  top: 0;
  left: 0;
  overflow-x: hidden;
  transition: all 300ms ease;
  transform: translateX(-300px);

  display: flex;
  flex-direction: column;
  background-color: $primary-background;
  box-shadow:
    0 8px 10px -5px rgba(0,0,0,0.2),
    0 16px 24px 2px rgba(0,0,0,0.14),
    0 6px 30px 5px rgba(0,0,0,0.12);

  .nav-user {
    padding: $spacer;
    border-bottom: 1px solid $dark-500;
    font-weight: bold;
    font-size: $font-size-lg;
    white-space: nowrap;

    .nav-item-detail {
      .primary {
        color: #FFF;
      }
      .secondary {
        color: $body-color;
      }
    }
  }

  .navbar {
    padding: $spacer * 0.25 0 0;
    .navbar-nav {
      width: 100%;
      flex: 1;
      .nav-link {
        padding: $spacer;
        color: #FFF;
      }
    }
    &.navbar-mobile {
      width: 100%;
      flex-flow: column;
      justify-content: flex-start;
      align-items: flex-start;
    }
    &.navbar-user {
      flex: 1;
      align-items: flex-start;
      flex-flow: column;
      justify-content: flex-end;
      padding: 20px;
      .nav-item {
        margin-top: 10px;
        color: #FFF;
      }
    }
  }
}

/*
On smaller screens, where height is less than 450px,
change the style of the sidenav (less padding and a smaller font size)
*/
@media (max-height: 450px) {
  .sidenav {padding-top: 15px;}
  .sidenav a {font-size: 18px;}
}

@media (max-width: 767.98px) {
  .navbar-brand {
    margin: 0;
  }
  .nav-auth {
    display: none;
  }
}

@media screen and (max-width: 380px) {
  .navbar-expand-lg {
    .navbar-brand {
      .brand {
        display: none;
      }
    }
  }
}

</style>
